/**
 * ---------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ---------------------------------------------------------------------------------------------
 */

import React from 'react';
import { normalize } from 'csstips';

import ReactDOM from 'react-dom';
import AppValidation from './app-validation';

normalize();

ReactDOM.render(
  <AppValidation />,
  document.getElementById('root')
);